import React from "react";
import Button from "@material-ui/core/Button";
import PropTypes from "prop-types";
import "./NotMe.css";
import locale from "../../utils/locale";
const style = {
  background: "linear-gradient(45deg, #EF201A 30%, #EF201A 90%)"
};

const NotMe = ({
  sellerCompany,
  year,
  model,
  make,
  color,
  onNotMeClick,
  disable
}) => {
  return (
    <div className="notme-content">
      <div className="text">
        {locale("introText", { sellerCompany, year, model, make, color })}
      </div>
      <Button
        className="br-25 red"
        onClick={onNotMeClick}
        variant="raised"
        color="secondary"
        disabled={disable}
        fullWidth
        style={style}
      >
        <strong>{locale("notMe")}</strong>
      </Button>
    </div>
  );
};

NotMe.propTypes = {
  sellerCompany: PropTypes.string,
  year: PropTypes.string,
  model: PropTypes.string,
  make: PropTypes.string,
  onNotMeClick: PropTypes.func,
  disable: PropTypes.bool
};

export default NotMe;



// WEBPACK FOOTER //
// ./src/components/NotMe/index.js